import ClipPlane from './ClipPlane.vue';
export default ClipPlane;
